export default __webpack_public_path__ + "static/media/IMG_008_r.07fc23d9.jpg";